import bucket from 'owa-timestream-asset-bucket';
import calendar from 'owa-timestream-asset-calendar';
import clock from 'owa-timestream-asset-clock';
import file from 'owa-timestream-asset-filepicker';
import { default as fluid, table } from 'owa-timestream-asset-fluid';
import goal from 'owa-timestream-asset-goal';
import link from 'owa-timestream-asset-link';
import location from 'owa-timestream-asset-location';
import note from 'owa-timestream-asset-note';
import people from 'owa-timestream-asset-people';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import task from 'owa-timestream-asset-task';
import tasklist from 'owa-timestream-asset-task-list';
import tips from 'owa-timestream-asset-tips';
import weather from 'owa-timestream-asset-weather';
import { mailItem } from 'owa-timestream-asset-mailitem';
import { calendarItem } from 'owa-timestream-asset-calendaritem';

/**
 * Usable assets.
 */
const FUNCTIONAL_ASSETS = [
    link,
    file,
    tasklist,
    goal,
    weather,
    note,
    location,
    calendar,
    people,
    fluid,
    table,
    clock,
    tips,
] as AssetDescriptor[];

/** Gets asset descriptors of items that should show up in the main asset menu, in order. */
const MENU_ASSETS = [
    calendar,
    tasklist,
    note,
    weather,
    goal,
    link,
    file,
    table,
    location,
    people,
    clock,
    tips,
    bucket,
] as AssetDescriptor[];

/**
 * These assets don't have any toolbox functionality, but calling them here to register them regardless
 * The order of registration does not matter
 */
const NON_TOOLBOX_ASSETS = [mailItem, calendarItem, task] as AssetDescriptor[];

/** Gets asset descriptors of tools that can create content during a paste operation, in order of precedence. */
const PASTE_PRECEDENCE = [fluid, file, link, note] as AssetDescriptor[];

/**
 * Gets the registry of all the assets
 */
export const ASSET_REGISTRY = {
    functionalAssets: FUNCTIONAL_ASSETS,
    pastePrecedence: PASTE_PRECEDENCE,
    nonToolboxAssets: NON_TOOLBOX_ASSETS,
    menuAssets: MENU_ASSETS,
};
